import $ from 'jquery';

import DDTemplates from './DDTemplates';
import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import Columns from './Columns';
import MobileMenu from './MobileMenu';
import RemoveLink from './RemoveLink';
import RemoveAria from './RemoveAria';
import SmartFooter from './SmartFooter';
import Placeholder from './Placeholder';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
// import ApplyForCamp from './ApplyForCamp';
import AccordionWrap from './AccordionWrap';
import Hero from './Hero';
import SliderStats from './Slider.Stats';
import FetchSourceImages from './FetchSourceImages';
import BackgroundImage from './BackgroundImage';
// import StarJiggle from './StarJiggle';
import Redirect from './Redirect';
import Banner from './Banner';
import LinksGen from './LinksGen';
import FilterSelect from './FilterSelect';
import Overviews from './Overviews';
import AlphaTabs from './AlphaTabs';
import BrowserCheck from './BrowserCheck';
import CalendarList from './CalendarList';
import CalendarFilters from './CalendarFilters';
import CustomPopup from './CustomPopup';

// Add the theme behaviors
Drupal.behavior((context) => {
  // eslint-disable-next-line no-new
  new FetchSourceImages(context);

  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Get browser and version
  $body.each((i, element) => {
    if (!element.browserCheck) {
      element.browserCheck = new BrowserCheck(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu && !element.MobileMenu) {
      element.Menu = new Menu(element);
      element.MobileMenu = new MobileMenu(element);
    }
  });

  // Apply for Camp Button on Mobile
  // $('#navigation', context).each((i, element) => {
  //   if (!element.apply) {
  //     element.apply = new ApplyForCamp(element);
  //   }
  // });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // eslint-disable-next-line no-new
  $('.translation-links a').click(function () {
    const lang = $(this).data('lang');
    // const $frame = $('.goog-te-menu-frame:first');
    $('.goog-te-menu-frame:first').contents().find('.goog-te-menu2-item span.text').each(function () {
      if ($(this).html() === lang) {
        $(this).click();
      }
    });
  });
  // reattach Google translate block
  const translate = $('#block-dd_google_translate-google_translate');
  const initialWidthCondition = $(window).width() < 1201;
  if (initialWidthCondition) {
    translate.attr('id', 'block-dd_google_translate-google_translate-2').detach().insertAfter($('#block-nice_menus-3'));
  } else {
    translate.attr('id', 'block-dd_google_translate-google_translate-1').detach().insertAfter($('.search-icon'));
  }
  $(window).resize(() => {
    const widthCondition = $(window).width() < 1201;
    if ($('#block-dd_google_translate-google_translate-1').length > 0 && widthCondition) {
      $('#block-dd_google_translate-google_translate-1').attr('id', 'block-dd_google_translate-google_translate-2').detach().insertAfter($('#block-nice_menus-3'));
    } else if ($('#block-dd_google_translate-google_translate-2').length > 0 && !widthCondition) {
      $('#block-dd_google_translate-google_translate-2').attr('id', 'block-dd_google_translate-google_translate-1').detach().insertAfter($('.search-icon'));
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      setTimeout(() => {
        element.SmartFooter = new SmartFooter(element, $footprint);
      }, 300);
    }
  });

  // Convert to columns
  $('.footerlinks', context).each((i, element) => {
    if (!element.columns) {
      element.columns = new Columns(element);
    }
  });

  // Banner
  $('.banner', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element);
      element.backgroundImage = new Banner(element);
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Fix image/video behaviors on Overviews
  $('.overview', context).each((i, element) => {
    if (!element.overview) {
      element.overview = new Overviews(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarList) {
      element.CalendarList = new CalendarList(element);
    }
  });

  // Calendar Filters for both views
  $('.calendar-feed, .view-grid-calendar', context).each((i, element) => {
    if (!element.CalendarFilters) {
      element.CalendarFilters = new CalendarFilters(element, {
        useFilters: true,
        filters: {
          'All Camp Events': 144,
          'Campers and Families': 224,
          Fundraising: 213,
          Volunteer: 263,
          Outpost: 265,
          'Outpost - Northern CA': 267,
          'Outpost - LA': 269,
          'Outpost - San Diego': 271,
        },
      });
    }
  });

  // Remove Link
  $('.home-action-headerband, .home-action-pods, .home-stats, .wt207 .node-teaser.pt277', context).each((i, element) => {
    if (!element.removeLink) {
      element.removeLink = new RemoveLink(element);
    }
  });
  $('.hero .field-image', context).each((i, element) => {
    if (!element.remLink) {
      element.remLink = new RemoveLink(element, {
        selector: 'a',
      });
      element.remLink = new RemoveAria(element, {
        selector: 'a',
      });
    }
  });

  // Make entire node clickable
  $('.home-action-pods .views-row', context).each((i, element) => {
    if (!element.redirect) {
      element.redirect = new Redirect(element);
    }
  });

  // Sets background image based on .node-image or .node-upper-image
  $('.home-video', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element);
    }
  });
  $('.home-action-pods .views-row', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, {
        destSelector: '.node-upper-image',
      });
    }
  });
  $('.home-story .views-row', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, {
        destSelector: '.field-image',
      });
    }
  });

  // Wraps each accordion element
  $('.accordion-heading', context).each((i, element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
    }
  });

  // Set placeholder of textfield using label
  $('.pods .type-textfield, .footer-subscribe .type-textfield', context).each((i, element) => {
    if (!element.placeholder) {
      element.placeholder = new Placeholder(element);
    }
  });

  // Hero background images and slider
  $('.hero', context).each((i, element) => {
    if (!element.hero) {
      element.hero = new Hero(element);
    }
  });

  // Stats slider
  $('.home-stats .view-content', context).each((i, element) => {
    if (!element.slider) {
      element.slider = new SliderStats(element);
    }
  });

  // Alphabetize tabs
  $('.wt239 .switch-tabs-related .dtabs', context).each((i, element) => {
    if (!element.alphaTabs) {
      element.alphaTabs = new AlphaTabs(element);
    }
  });

  // Medical services dropdown
  $('.wt239 .switch-tabs-related', context).each((i, element) => {
    if (!element.linksGen) {
      element.linksGen = new LinksGen(element, {
        linksWrapper: 'filters-dropdown',
        parent: '.block-content',
        original: 'span',
        originalWrapper: '.dtabs .tab',
        hasAnchor: false,
        alphabetical: true,
      });
    }
  });
  $('.wt239 .switch-tabs-related', context).each((i, element) => {
    // Creates a select box from all of the related links.
    if (!element.filterSelect) {
      element.filterSelect = new FilterSelect(element, {
        selector: '.filters-dropdown',
        placeholder: 'Filter by Medical Condition',
      });
    }
  });

  // Star Jiggler
  // $('.hero .block-title-text, .home-stats .block-title-text, .home-video .block-inner', context)
  //   .each((i, element) => {
  //     if (!element.jiggler) {
  //       element.jiggler = new StarJiggle(element);
  //     }
  //   });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  setTimeout(() => {
    $body.addClass('delayed');
  }, 200);

  // Add aria-label to right sidebar image links
  const imageLinks = document.querySelectorAll('.page-right article');
  if (imageLinks) {
    imageLinks.forEach((e) => {
      const title = e.querySelector('.node-header span.title').textContent;
      const link = e.querySelector('.node-links a');
      link.setAttribute('aria-label', title);
    });
  }

  $('.custom-popup', context).each((i, element) => {
    if (!element.customPopup) {
      element.customPopup = new CustomPopup(element);
    }
  });
});
